<script lang="ts">import JoinNow from "../icons/join-now.svg";
import { cfgToThemeCdnPath, stateHasSports } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { isNotificationsOpen, isPlayerChatOpen, loggedIn, toSiteUrl } from "@infinitro/global";
import TopCard from "./top-card.svelte";
export let isBigScreen = false;
</script>

<a
	class:referral-link-card={$stateHasSports}
	class:referral-link-card-special={!$stateHasSports}
	href={toSiteUrl($loggedIn ? '/referral-dashboard' : '/referral/', $loggedIn) || '#'}
>
	<div class="top-card-container">
		<TopCard
			backgroundImage={cfgToThemeCdnPath('/top-section/small-bottom-right.png')}
			backgroundImagePosition={$stateHasSports ? 'top' : 'center'}
			height="100%"
			width="100%"
		/>
		<div class="content-top-card">
			<div class="content-wrapper">
				<div class="card-title">
					<h2 class="card-section-title">
						<span>{$t(Verbiage.referral).toUpperCase()}</span>
					</h2>
				</div>
				<div class="d-flex">
					<p
						class="card-section-body"
						class:card-section-body-wider={$isPlayerChatOpen || $isNotificationsOpen}
					>
						<span>{$t(Verbiage.referral_subtitle)}</span>
					</p>
				</div>
			</div>
		</div>
	</div>
</a>

<style>
	a {
		height:
			100%;
		width:
			100%;
}

	@media (min-width: 1280px) {
		a {
				width:
			54%;
		}
	}

	.content-top-card {
		position:
			absolute;
		z-index:
			40;
		display:
			flex;
		height:
			100%;
		width:
			100%;
		align-items:
			center;
		justify-content:
			space-between;
		padding:
			1rem;
}

	.content-wrapper {
		display:
			flex;
		height:
			100%;
		width:
			100%;
		flex-direction:
			column;
		justify-content:
			space-between;
}

	@media (min-width: 1280px) {
		.content-top-card {
				align-items:
			center;
				justify-content:
			space-between;
				padding:
			0.75rem;
		}
	}

	@media (min-width: 1440px) {
		.content-top-card {
				padding:
			1.25rem;
		}
	}

	.top-card-container {
		position:
			relative;
		display:
			flex;
		height:
			100%;
		width:
			100%;
		cursor:
			pointer;
		align-items:
			center;
		justify-content:
			space-between;
}

	.top-card-container img {
		position:
			absolute;
		top:
			20%;
		right:
			-3%;
		z-index:
			40;
		height:
			60%;
		max-width:
			none;
}

	@media (min-width: 1280px) {
		.top-card-container img {
				top:
			15%;
		}
	}

	@media (min-width: 640px) and (max-width: 1279px) {
		.top-card-container img {
				left:
			75%;
				--tw-translate-x:
			-75%;
				transform:
			translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		}
	}

	.d-flex {
		display:
			flex;
		align-items:
			center;
		justify-content:
			flex-start;
		gap:
			0.25rem;
}

	.d-flex img {
		position:
			static;
		height:
			1rem;
		width:
			1rem;
}

	.text-with-shadow {
		text-shadow:
			0px 0px 6px rgba(0, 0, 0, 1),
			0px 0px 3px rgba(0, 0, 0, 1);
	}

	@media (min-width: 640px) {
		.hide-tablet {
				display:
			none;
		}
	}

	@media (min-width: 1280px) {
		.hide-tablet {
				display:
			flex;
		}
	}

	/*
      .hide-mobile {
        @apply w-full hidden flex-col;
      }
      */

	@media (min-width: 640px) {
		.hide-mobile {
				display:
			flex;
		}
	}

	@media (min-width: 1280px) {
		.hide-mobile {
				width:
			auto;
		}
	}

	.card-title {
		display:
			flex;
		width:
			100%;
}

	@media (min-width: 1280px) {
		.card-title {
				justify-content:
			flex-start;
		}
	}

	.card-section-title {
		font-size:
			14px;
		font-weight:
			700;
		--tw-text-opacity:
			1;
		color:
			rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family:
			var(--font-alternative-2);
}

	@media (min-width: 640px) {
		.card-section-title {
				font-size:
			24px;
		}
	}

	@media (min-width: 1280px) {
		.card-section-title {
				font-size:
			18px;
			font-size: clamp(8px, 1.1cqi, 18px) !important;
		}
	}

	.card-section-body {
		max-width:
			80%;
		font-size:
			9px;
		--tw-text-opacity:
			1;
		color:
			rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family:
			var(--font-alternative-2);
		text-align: start !important;
		text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.5);
}

	@media (min-width: 640px) {
		.card-section-body {
				max-width:
			60%;
				font-size:
			12px;
			font-size: clamp(8px, 0.8cqi, 12px) !important;
		}
		.card-section-body-wider {
				max-width:
			80%;
		}
	}

	@media (min-width: 1600px) {
		.card-section-body {
				font-size:
			13px;
		}
	}
</style>
